export default $.i18n({
  root: {
    open: 'Afficher tout',
    close: 'Masquer tout'
  },
  en: {
    open: 'Display all',
    close: 'Hide all'
  },
  de: {
    open: 'Alles anzeigen',
    close: 'Alles ausblenden'
  },
  lb: {
    open: 'Alles weisen',
    close: 'Alles maskéieren'
  }
});
